<template>
  <div>
    <v-alert
      v-if="isAsesor && !isTutup"
      icon="mdi-information"
      close-text="Tutup"
      colored-border
      border="left"
      type="info"
      class="bg-notif"
      color="yellow darken-2"
    >
      Anda diharapkan <b>melakukan pengaturan slot menguji</b> mulai tanggal
      <b>( {{ $durasi(tglBukaJadwal, tglTutupJadwal) }} )</b>
    </v-alert>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row dense class="my-2">
              <v-col>
                <h1 class="headline info--text">
                  <strong>{{ fLabel }} dan Wawancara</strong>
                </h1>
              </v-col>
              <v-col class="text-right">
                <v-chip v-if="isAsesor" color="pink" dark>
                  <b>Asesor {{ isAsesorA ? 'A' : 'B' }}</b>
                </v-chip>
              </v-col>
            </v-row>
            <div v-if="isAsesor">
              <template v-if="isTutup">
                <v-row>
                  <v-col cols="12" md="8" sm="12">
                    <div>
                      Semua Waktu Sesi / Slot ujian adalah dalam <b>WIB</b>, Apabila Anda domisili di waktu
                      <b>WIT / WITA</b> maka sesuaikan Waktu Anda dengan <b>WIB</b>
                    </div>
                    <div class="mt-3"> Pastikan anda bersiap <b>20 Menit</b> Sebelum Sesi Dimulai </div>
                    <div class="blue--text mt-3">
                      Cek tautan
                      <a
                        href="https://id.wikipedia.org/wiki/Zona_waktu_Indonesia#:~:text=Indonesia%20terbagi%20atas%20tiga%20zona%20waktu%20yaitu%3A&text=Waktu%20Indonesia%20Tengah%20atau%20WITA,UTC%2B09%3A00)"
                        target="_blank"
                        class="font-weight-bold"
                      >
                        Wikipedia
                      </a>
                      untuk detil pembagian Zona waktu di Indonesia
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" sm="12">
                    <v-img :src="$imgUrl('timezone.jpg')" max-width="400" max-height="300" />
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <p>
                  Silahkan atur jadwal kapan Anda melakukan Sesi Penilaian {{ fLabel }} dan Wawancara. Anda memiliki
                  waktu hingga <b>( {{ $localDate(tglTutupJadwal, false, true) }} )</b> untuk mengatur Jadwal Sesi
                  {{ fLabel }}
                  dan Wawancara. Apabila Anda mengalami kendala terkait berlangsungnya {{ fLabel.toLowerCase() }} dan
                  wawancara (dengan pasangan / kandidat), silahkan hubungi tim pemantau dibawah ini.
                </p>
              </template>
              <v-row class="my-1" dense>
                <v-col v-for="(info, index) in infoAsesors" :key="index" cols="12" md="4" sm="12">
                  <v-list dense two-line outlined>
                    <v-list-item>
                      <v-list-item-content>
                        <div class="caption">{{ info.title }}</div>
                        <div>
                          <b>{{ $getDeepObj(info, 'nama') || '' }}</b
                          ><br />
                          <template v-if="$getDeepObj(info, 'no_hp')">
                            {{ `+62${Number($getDeepObj(info, 'no_hp'))}` }}
                            <v-icon color="success" small dark @click="onCall(Number($getDeepObj(info, 'no_hp')))">
                              mdi-whatsapp
                            </v-icon>
                          </template>
                          <template v-else-if="$getDeepObj(info, 'no_telpon')">
                            {{ `+62${Number($getDeepObj(info, 'no_telpon'))}` }}
                          </template>
                          <template v-else>-</template>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
              <div class="indigo--text my-2">
                <v-icon left small color="indigo">mdi-clock</v-icon>
                <span v-if="isAsesorA">Set</span> Jadwal {{ fLabel }} dan Wawancara
                <b>{{ $durasi(tglBukaJadwal, tglTutupJadwal) }}</b>
                <template v-if="isAsesor && !isTutup">
                  <div class="indigo--text">
                    <v-icon left color="indigo" small>
                      mdi-information
                    </v-icon>
                    <span v-if="isAsesorA">
                      Saat ini Anda bertugas sebagai <b>Asesor A</b>, silahkan set jadwal pelaksanaan dan google meet
                      room url pada tombol dibawah ini
                    </span>
                    <span v-else>
                      Saat ini Anda bertugas sebagai <b>Asesor B</b>, silahkan set google meet room url pada tombol
                      dibawah ini
                    </span>
                  </div>
                </template>
              </div>
              <v-divider />
              <v-row dense class="my-2">
                <v-col>
                  <v-btn
                    v-if="
                      $allow(`psp-${api}-simulasi-ajar.get-slot`) ||
                        $allow(`psp-${api}-simulasi-ajar.get-slot-gabungan`)
                    "
                    color="primary"
                    small
                    depressed
                    @click="onEdit"
                    >{{ isTutup ? 'Lihat Jadwalku' : isAsesorA ? 'Atur Jadwal' : 'Lihat Jadwalku' }}
                  </v-btn>
                </v-col>
                <v-col v-if="$allow(`psp-${api}-asesor-kinerja.download-simulasi-ajar`)" class="text-right">
                  <v-btn color="pink" :dark="!isLaporanKinerja" @click="onKinerja" :disabled="isLaporanKinerja" small>
                    <v-icon left>mdi-text-box-check</v-icon> laporan kinerja</v-btn
                  >
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <b>Apa itu {{ fLabel.toLowerCase() }} ? </b>adalah suatu metode pelatihan pendidikan dalam skala kecil dan
              terbatas dalam rangka meningkatkan keterampilan mengajar dan mendidik. Sasaran utama Pembelajaran mikro
              adalah para pendidik di bidang keguruan dan pengajaran, Secara umum, pembelajaran mikro bertujuan untuk
              bekal keterampilan mengajar bagi para calon pendidik
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <statistik :analitik="analitik" fungsi="simulasi-ajar"></statistik>
    <v-card tile class="elevation-1">
      <v-card-title class="pa-0">
        <base-table-header
          btn-filter
          :btnDownload="
            $allow(`psp-${api}-simulasi-ajar.download-status-jadwal`) ||
              $allow(`psp-${api}-simulasi-ajar.download-jadwal`)
          "
          @download="onDownloadList"
          @search="onSearch"
          @reload="onReload"
          @filter="onFilter"
        >
          <template v-slot:toolbar>
            <v-select
              class="mt-7"
              v-model="params.gelombang"
              :items="mGelombang"
              item-text="text"
              item-value="value"
              dense
              outlined
              @change="onAngkatan"
              style="max-width: 180px"
            />
          </template>
          <template v-slot:subtitle>
            <div class="body-1">Daftar Kandidat <span class="blue--text" v-text="total" /> </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider></v-divider>
      <base-list-filter
        ref="filter"
        title="Saring Data"
        :filtered="filtered"
        :filters="formFilter"
        :paramsFilter="filters"
        @save="filterStatus"
      />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" :md="isAsesor ? 4 : 2">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-account-circle</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-if="isAsesor" class="caption grey--text" v-text="'Nama Kandidat'" />
                          <h2 class="body-1 bluel-grey--text text--darken-2">
                            <div>
                              {{ $getDeepObj(item, 'ptk.data.nama') }}
                              <template
                                v-if="!isAsesor && ($getDeepObj(item, 'ptk.data.no_hp') || $getDeepObj(item, 'no_wa'))"
                              >
                                <v-icon
                                  color="success"
                                  small
                                  dark
                                  @click="
                                    onCall(Number($getDeepObj(item, 'no_wa') || $getDeepObj(item, 'ptk.data.no_hp')))
                                  "
                                >
                                  mdi-whatsapp
                                </v-icon>
                              </template>
                            </div>
                            <template v-if="Number(item.k_proses_simulasi_psp) >= 4">
                              <template v-if="!$getDeepObj(item, 'psp_simulasis.data.0.url_rekaman')">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="red" v-on="on" small> mdi-image-off </v-icon>
                                  </template>
                                  <span>Belum masukan hasil capture</span>
                                </v-tooltip>
                              </template>
                              <template v-if="!isKonfirmasiAsesor(item)">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="red" v-on="on" size="18"> mdi-pencil-off </v-icon>
                                  </template>
                                  <span>Asesor B belum melakukan konfirmasi</span>
                                </v-tooltip>
                              </template>
                            </template>
                            <template v-if="isAsesor">
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-icon color="primary" v-on="on">
                                    mdi-alpha-{{ isUtama(item) ? 'a' : 'b' }}-box
                                  </v-icon>
                                </template>
                                <span>Anda Berperan Sebagai {{ isUtama(item) ? 'Asesor A' : 'Asesor B' }}</span>
                              </v-tooltip>
                            </template>
                          </h2>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <template v-if="isAsesor">
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <v-list-item-title class="caption grey--text" v-text="'Waktu Ujian'"></v-list-item-title>
                            {{ $localDate($getDeepObj(item, 'tgl_simulasi')) || '-' }}
                            <div v-if="$getDeepObj(item, 'tgl_simulasi')">
                              [S{{ $getDeepObj(item, 'slot') }}]
                              {{ $localTime($getDeepObj(item, 'jam_mulai')) || '-' }}
                              {{ $localTime($getDeepObj(item, 'jam_selesai')) || '-' }}
                            </div>
                            <div v-else>-</div>
                            <div v-if="$getDeepObj(item, 'tgl_simulasi') && isAsesor" class="red--text">
                              <p
                                class="grey--text"
                                v-if="isMulaiWawancara($getDeepObj(item, 'psp_simulasis.data.0'))"
                              />
                              <div v-else>{{ getDurasi($getDeepObj(item, 'psp_simulasis.data.0')) }}</div>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <v-list-item-title
                              class="caption grey--text"
                              v-text="'Pasangan Asesor'"
                            ></v-list-item-title>
                            <div v-if="$getDeepObj(item, 'psp_simulasis.data.0')">
                              <b>{{ getPasangan(item)['nama'] || '-' }}</b>
                              <br />
                              <div v-if="getPasangan(item)['no_telpon']">
                                {{ '+62' + Number(getPasangan(item)['no_telpon'] || '-') }}
                              </div>
                              <div v-if="getPasangan(item)['no_hp']">
                                {{ '+62' + Number(getPasangan(item)['no_hp'] || '-') }}
                                <v-icon
                                  color="success"
                                  small
                                  dark
                                  @click="onCall(Number(getPasangan(item)['no_hp'] || ''))"
                                >
                                  mdi-whatsapp
                                </v-icon>
                              </div>
                            </div>
                            <div v-else>-</div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <v-list-item-title class="caption grey--text" v-text="'Nama Asesor'"></v-list-item-title>
                            <div>
                              {{ $getDeepObj(item, 'psp_simulasis.data.0.akun_penilai.data.nama') || '-' }}
                              <template v-if="$getDeepObj(item, 'psp_simulasis.data.0.akun_penilai.data.no_hp')">
                                <v-icon
                                  color="success"
                                  small
                                  dark
                                  @click="
                                    onCall(Number($getDeepObj(item, 'psp_simulasis.data.0.akun_penilai.data.no_hp')))
                                  "
                                >
                                  mdi-whatsapp
                                </v-icon>
                              </template>
                            </div>
                            <div
                              v-if="
                                $getDeepObj(item, 'psp_simulasis.data.0.akun_penjadwal.data.akun_id') ===
                                  $getDeepObj(item, 'psp_simulasis.data.0.akun_penilai.data.akun_id')
                              "
                            >
                              {{ $getDeepObj(item, 'psp_simulasis.data.0.akun_pendamping.data.nama') || '-' }}
                              <template v-if="$getDeepObj(item, 'psp_simulasis.data.0.akun_pendamping.data.no_hp')">
                                <v-icon
                                  color="success"
                                  small
                                  dark
                                  @click="
                                    onCall(Number($getDeepObj(item, 'psp_simulasis.data.0.akun_pendamping.data.no_hp')))
                                  "
                                >
                                  mdi-whatsapp
                                </v-icon>
                              </template>
                            </div>
                            <div v-else>
                              {{ $getDeepObj(item, 'psp_simulasis.data.0.akun_penjadwal.data.nama') || '-' }}
                              <template v-if="$getDeepObj(item, 'psp_simulasis.data.0.akun_penjadwal.data.no_hp')">
                                <v-icon
                                  color="success"
                                  small
                                  dark
                                  @click="
                                    onCall(Number($getDeepObj(item, 'psp_simulasis.data.0.akun_penjadwal.data.no_hp')))
                                  "
                                >
                                  mdi-whatsapp
                                </v-icon>
                              </template>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>

                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <template v-if="!isTerkendala(item) && Number(item.k_proses_simulasi_psp) === 6">
                              <div v-if="$getDeepObj(item, 'psp_profil_nilais.data')">
                                <div class="caption grey--text">Kategori Simulasi</div>
                                <v-chip
                                  v-if="$getDeepObj(item, 'psp_profil_nilais.data.0.nilai')"
                                  small
                                  :color="
                                    kategoris[Number($getDeepObj(item, 'psp_profil_nilais.data.0.nilai'))]['color']
                                  "
                                  dark
                                >
                                  {{
                                    'Kategori ' +
                                      kategoris[Number($getDeepObj(item, 'psp_profil_nilais.data.0.nilai'))]['text']
                                  }}
                                </v-chip>
                                <span v-else>-</span>
                                <div class="caption grey--text">Kategori Wawancara</div>
                                <v-chip
                                  v-if="$getDeepObj(item, 'psp_profil_nilais.data.1.nilai')"
                                  small
                                  :color="
                                    kategoris[Number($getDeepObj(item, 'psp_profil_nilais.data.1.nilai'))]['color']
                                  "
                                  dark
                                >
                                  {{
                                    'Kategori ' +
                                      kategoris[Number($getDeepObj(item, 'psp_profil_nilais.data.1.nilai'))]['text']
                                  }}
                                </v-chip>
                                <span v-else>-</span>
                              </div>
                              <div v-else>-</div>
                            </template>
                            <template v-else>
                              <v-list-item-title class="caption grey--text" v-text="'Kategori'"></v-list-item-title>
                              <div>-</div>
                            </template>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>

                      <v-col cols="12" md="2">
                        <v-list-item class="px-0">
                          <v-list-item-content>
                            <v-list-item-title class="caption grey--text" v-text="'Tanggal Ujian'"></v-list-item-title>
                            <div>{{ $localDate($getDeepObj(item, 'tgl_simulasi')) || '-' }}</div>
                            <div v-if="$getDeepObj(item, 'tgl_simulasi')">
                              {{ $localTime($getDeepObj(item, 'jam_mulai')) || '-' }} -
                              {{ $localTime($getDeepObj(item, 'jam_selesai')) || '-' }}
                            </div>
                            <div v-else>-</div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-col>
                    </template>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title class="caption grey--text" v-text="'Status'"></v-list-item-title>
                          <div>
                            <v-chip class="ml-1" small :color="statustNilai(item)['color']" dark>
                              {{ statustNilai(item)['text'] }}
                            </v-chip>
                            <template v-if="isTerkendala(item)">
                              <div :class="`${statusSusulan(item)['color']}--text caption mt-1`">
                                <v-icon :color="`${statusSusulan(item)['color']}`" small style="top: -2px"
                                  >mdi-alert-circle</v-icon
                                >
                                {{ statusSusulan(item)['text'] }}
                              </div>
                            </template>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col v-if="isAsesor" cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content v-if="$allow(`psp-${api}-simulasi-ajar.update-nilai`)">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi Selanjutnya</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn
                              small
                              block
                              :disabled="isTutupPenilaian"
                              :color="aksiBtn(item)['color']"
                              @click="onActions(item)"
                            >
                              {{ aksiBtn(item)['label'] }}
                            </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col v-else cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi Selanjutnya</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn small dark block color="blue" @click="onActions(item)"> Lihat Laporan </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text v-if="$allow(`psp-${api}-simulasi-ajar.jadwal-ulang`)">
                  <template v-if="$allow(`psp-${api}-simulasi-ajar.jadwal-ulang`, item.policies)">
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </template>
                  <template v-else>
                    <v-icon class="ml-1" color="white">mdi-dots-vertical</v-icon>
                  </template>
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
        <v-alert text color="blue">
          <v-container class="red--text px-0">
            <table>
              <tr>
                <td style="vertical-align: top"><v-icon color="red" left> mdi-image-off </v-icon></td>
                <td>
                  <span>
                    Apabila melihat ikon / gambar ini dibawah daftar kandidat, maka segera hubungi Asesor A untuk
                    <b>melengkapi url capture/screenshot SMWW</b>. Kelengkapan capture/screenshot SMWW merupakan salah
                    satu parameter selesainya penilaian kandidat.
                  </span>
                </td>
              </tr>
              <tr>
                <td style="vertical-align: top"><v-icon color="red" left> mdi-pencil-off </v-icon></td>
                <td>
                  <span>
                    Apabila melihat ikon / gambar ini dibawah daftar kandidat, maka Asesor B
                    <b>belum mengkonfirmasi penilaian</b> yang diberikan Asesor A.
                  </span>
                </td>
              </tr>
            </table>

            <template v-if="isAsesor">
              <table>
                <tr>
                  <td style="vertical-align: top">
                    <v-icon color="primary" left>
                      mdi-alpha-a-box
                    </v-icon>
                  </td>
                  <td>
                    <div class="blue--text">
                      <span>
                        Jika anda melihat ikon / gambar ini pada nama kandidat, maka anda bertugas sebagai
                        <b>Asesor A</b> yang diharuskan untuk memvalidasi kegiatan yang sudah berlangsung (sukses,
                        penjadwalan kembali, atau gagal), memasukkan tautan hasil capture, memberikan penilaian dan
                        catatan pada rubrik.
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="vertical-align: top">
                    <v-icon color="primary" left>
                      mdi-alpha-b-box
                    </v-icon>
                  </td>
                  <td>
                    <div class="blue--text">
                      <span>
                        Jika anda melihat ikon / gambar ini pada nama kandidat, maka anda bertugas sebagai
                        <b>Asesor B</b> yang diharuskan untuk mendampingi Asesor A dalam kegiatan, melakukan konfirmasi
                        penilaian dan catatan pada rubrik berdasarkan penilaian Asesor A.
                      </span>
                    </div>
                  </td>
                </tr>
              </table>
            </template>
          </v-container>
        </v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <!-- modal form -->
    <base-modal-full
      ref="modal"
      :title="formulir.title"
      @save="onSave"
      :autoClose="formulir.autoClose"
      :useSave="!formulir.isPreview"
      @close="onClose"
    >
      <component
        ref="formulir"
        generalError
        :is="formulir.form"
        :id="formulir.id"
        :initValue="formulir.init"
        :type="'guru'"
        :akun="akun"
        :isPreview="formulir.isPreview"
        :configs="configs"
        :useReguler="!isTutup"
        :useSusulan="isTutup"
        :blockSlots="blokirs"
        :isAsesor="isAsesor"
        :akses="api"
        @info="onDetil"
        @konfig="
          () => {
            getKonfig({ api: api, config: deffProfil });
          }
        "
      ></component>
    </base-modal-full>
    <base-modal-full ref="kinerja" title="Laporan Kinerja" :useSave="false">
      <form-kinerja-asessor
        ref="formkinerja"
        :akun="akun"
        :title="fLabel"
        @download="onDownloadKinerja"
      ></form-kinerja-asessor>
    </base-modal-full>
    <v-dialog v-model="dialog" max-width="900" transition="dialog-bottom-transition" scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat dark color="secondary">
            <v-toolbar-title>Detail Kandidat</v-toolbar-title>
            <v-spacer />
            <v-btn right icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text v-show="dialog">
          <detil-wawancara
            ref="infokandidat"
            :title="fLabel"
            :fullscreen="false"
            :detail="detail"
            :useLink="false"
            :isAsesor="isAsesor"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import list from '@mixins/list';
import mixin from './mixin';
import base from '../base/mixin';
import { mapState, mapActions } from 'vuex';
import FormPenilaianMicroteaching from '../formulir/PenilaianMicroteaching';
import FormKinerjaAsessor from '../formulir/KinerjaAsesor';
import FormWawancara from '../formulir/Wawancara';
import DetilWawancara from '../formulir/DetilWawancara';
import MainContent from '../component/KontenWawancara';
import Statistik from '../component/StatistikSm';
import Actions from './actions';
export default {
  name: 'PenilaianMicroteaching',
  mixins: [list, mixin, base],
  components: { FormWawancara, DetilWawancara, FormPenilaianMicroteaching, FormKinerjaAsessor, MainContent, Statistik },
  data() {
    return {
      actions: Actions,
      formulir: {},
      detail: {},
      dialog: false,
      tabJadwal: 0,
      pemantaus: [],
      asesors: [],
      listLaporan: [],
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => Object.assign({}, state.data.akun),
      groups: (state) => state.data && state.data.groups,
      pspConfig: (state) => (state.data && state.data.config) || {},
    }),

    ...mapState('microteaching', {
      configSlot: (state) => Object.assign({}, state.configs) || {},
      wktOnline: (state) => (state && state.wktOnline) || '',
      stats: (state) => (state && state.statistik) || {},
    }),

    fungsi() {
      return this.$route.meta.tipe || 'kasek';
    },

    kProfil() {
      return this.fungsi === 'kasek' ? 2 : 1;
    },

    fLabel() {
      return this.fungsi === 'kasek' ? 'Simulasi Mengajar' : 'Simulasi Melatih';
    },

    deffProfil() {
      return {
        k_profil_psp: this.kProfil,
        gelombang: this.params.gelombang,
      };
    },

    api() {
      return this.$route.meta.api;
    },

    mGelombang() {
      const jenis = this.fungsi === 'kasek' ? 'peserta' : 'pelatih_ahli';
      const result = [];

      for (let i = Number(this.pspConfig[jenis]['gelombang']); i > 0; i--) {
        result.push({ text: `Angkatan ${i}`, value: i });
      }

      return result;
    },
  },
  created() {
    this.$set(this.params, 'count', 20);
    this.$set(
      this.params,
      'gelombang',
      this.$getDeepObj(this, `pspConfig.${this.fungsi === 'kasek' ? 'peserta' : 'pelatih_ahli'}.gelombang`)
    );

    // Set url api
    Object.assign(this.attr, { api: this.api });
    this.listLaporan = [
      {
        key: 'jadwal',
        label: `Daftar Jadwal Kandidat`,
        acl: `psp-${this.api}-simulasi-ajar.download-jadwal`,
      },
      {
        key: 'status-jadwal',
        label: `Daftar Status Set Jadwal`,
        acl: `psp-${this.api}-simulasi-ajar.download-status-jadwal`,
      },
      {
        key: 'nilai',
        label: `Daftar Laporan Nilai Tahap 2`,
        acl: `psp-${this.api}-simulasi-ajar.download-nilai`,
      },
    ];

    this.getKonfig({ api: this.api, config: this.deffProfil });
    this.fetchAsesor({}, 'asesors');
    this.fetchStatistik();
  },
  methods: {
    ...mapActions('microteaching', {
      fetch: 'fetch',
      update: 'update',
      nilai: 'nilai',
      getDetail: 'getDetail',
      getSlot: 'slot',
      getKonfig: 'konfig',
      updateSlot: 'updateSlot',
      reschedule: 'reschedule',
      getStatistik: 'getStatistik',
      getAsesor: 'getAsesor',
      getKinerja: 'unduhKinerja',
      downloadList: 'downloadList',
    }),
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
